export default __webpack_public_path__ + "static/char-s-30-ko-28c86adc7d9f812dfbcbf4362f91dd55.png";